// extracted by mini-css-extract-plugin
export default {"bg":"TooltipUI_bg__2fRZI","tooltipContainer":"TooltipUI_tooltipContainer__3VkoU","tooltipInverse":"TooltipUI_tooltipInverse__rEyRd","close":"TooltipUI_close__M1s4o"};